import { User } from "../models";

export default {
  /**
   * @deprecated will be removed in next version
   */
  getToken: () => {
    try {
      return localStorage.getItem("token") as string;
    } catch (err) {
      /* eslint-disable */
      console.log("Error ", err);
      /* eslint-enable */
      return "";
    }
  },

  set: (user: User) => {
    if (user) localStorage.setItem("user", JSON.stringify(user));
  },
  get: () => {
    const user = localStorage.getItem("user");

    return user ? JSON.parse(user) : null;
  },
  /**
   * removes user
   *
   */
  remove: () => {
    localStorage.removeItem("user");
  },
  /**
   * clear entire localStorage
   *
   */
  removeAll: () => {
    localStorage.clear();
  },
};
